import React, { useContext } from 'react'
import styled from 'styled-components'
import { graphql, StaticQuery } from 'gatsby'
import media from 'css-in-js-media'

import Container from './Container'
import { Row, Col } from 'react-styled-flexboxgrid'
import LayoutContext from './LayoutContext'
import FooterColumn from './FooterColumn'
import AccordionWrap from './AccordionWrap'
import { DesktopView, MobileView } from '../styles/Utils'
import { Variables } from '../styles/Variables'
import { AccordionSectionHeader } from './AccordionSection'
import SocialLinks from './SociaLink'
import PreFooter from './PreFooter'

const Andermatt_logo = require('../images/ASA_Logo.png') as string

const FooterWrapper = styled.div`
    padding-bottom: 60px;
    position: relative;
    z-index: 100;
    padding-top: 40px;
    background-color: ${Variables.color.pazola};
    border-top: 1px solid ${Variables.color.white};
    color: white;

    ${media('>=desktop')} {
        padding-top: 60px;
        padding-bottom: 60px;
    }

    ${AccordionSectionHeader} {
        font-family: ${Variables.font.title};
        color: ${Variables.color.white};
        font-size: 20px;
        letter-spacing: 0.0015em;
        text-transform: uppercase;

        svg path {
            stroke: ${Variables.color.white};
        }

        ${media('<desktop')} {
            font-weight: 400;
        }
    }
`

const FooterCopyWrap = styled.div`
    margin: 0;
    color: ${Variables.color.white};
    ${media('>=desktop')} {
        margin: 0 0 82px;
    }
    ${Col} {
        width: 100%;
    }

    ${MobileView} {
        width: 100%;
        svg path {
            stroke: ${Variables.color.white};
        }
    }
`

const Copyright = styled.div`
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.0025em;
    color: ${Variables.color.white};
    text-transform: uppercase;

    ${media('<desktop')} {
        font-size: 12px;
        line-height: 130%;
    }

    &:before {
        content: '© ';
        font-family: 'Helvetica', 'Arial', sans-serif;
    }
`
const LogoWrap = styled.div`
    ${media('<desktop')} {
        width: 100%;
    }
`

const Logo = styled.div`
    ${media('<desktop')} {
        padding: 35px 0;
    }

    img {
        height: 55px;
    }

    a:hover {
        opacity: 0.8;
    }
`

const LinksColumn = styled(Col)``

const FooterBottomRow = styled(Row)`
    ${media('<desktop')} {
        padding-top: 55px;
        /* flex-direction: column-reverse; */
    }
`

export const FooterContainer: React.FC = ({ data }) => {
    const { currentLang } = useContext(LayoutContext)
    const langPrefix = currentLang.prefix
    const Footerdata = data.allContentfulFooter.edges.find((i) => i.node.node_locale == currentLang.langKey).node
    const { footerColumns } = Footerdata

    return (
        <>
            <PreFooter data={Footerdata} />
            <FooterWrapper>
                <Container>
                    <FooterCopyWrap>
                        {footerColumns && (
                            <>
                                <Row start="xs">
                                    {footerColumns.map((footerColumn, i) => (
                                        <FooterColumn footerColumn={footerColumn} key={i} />
                                    ))}
                                </Row>
                            </>
                        )}
                    </FooterCopyWrap>
                    <FooterBottomRow between="md" middle="md">
                        <Copyright>{Footerdata.copyright}</Copyright>
                        <LogoWrap>
                            <Logo>
                                <a href="https://andermatt-swissalps.ch" target="_blank">
                                    <img src={Andermatt_logo} alt="" />
                                </a>
                            </Logo>
                        </LogoWrap>
                    </FooterBottomRow>
                </Container>
            </FooterWrapper>
        </>
    )
}

const Footer = (props) => (
    <StaticQuery
        query={graphql`
            query footerQuery {
                allContentfulFooter(filter: { property: { name: { regex: "/pazola/i" } } }) {
                    edges {
                        node {
                            copyright
                            footerCopy {
                                childMarkdownRemark {
                                    html
                                }
                            }
                            subfooter {
                                copy {
                                    childMarkdownRemark {
                                        html
                                    }
                                }
                                headingTitle {
                                    headingTitle
                                }
                            }
                            footerColumns {
                                title
                                subtitle {
                                    childMarkdownRemark {
                                        html
                                    }
                                }
                                links {
                                    name
                                    internalFile {
                                        file {
                                            url
                                            contentType
                                        }
                                    }
                                    internalLink {
                                        ... on ContentfulSimplePage {
                                            slug
                                            title
                                        }
                                        ... on ContentfulPage {
                                            slug
                                            title
                                        }
                                    }
                                    externalLink
                                }
                                buttons {
                                    text
                                    buttonLink {
                                        internalFile {
                                            file {
                                                url
                                                contentType
                                            }
                                        }
                                        internalLink {
                                            ... on ContentfulSimplePage {
                                                slug
                                                title
                                            }
                                            ... on ContentfulPage {
                                                slug
                                                title
                                            }
                                        }
                                        externalLink
                                    }
                                }
                            }
                            node_locale
                        }
                    }
                }
            }
        `}
        render={(data) => <FooterContainer data={data} {...props} />}
    />
)

export default Footer
